import { userConstants } from "../constants/login.constants";

 function documentHistoryAsicDocDetails(state = {}, action) {
    switch (action.type) {
        case userConstants.DOCUMENTHISTORYASICREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.DOCUMENTHISTORYASICREPORT_SUCCESS:
            return {
                items: action.documentHistoryAsicDocDetails
            };
        case userConstants.DOCUMENTHISTORYASICREPORT_FAILURE:
            return {
                error: action.errorAsicDocumentHistory
            };
        default:
            return state
    }
}
export default documentHistoryAsicDocDetails;